import React from 'react';
import { Booth } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import VyButton from '../../../../common/VyButton';
import { VyImage } from '../../../../common/VyImage';
import { ContactShareModal } from '../../../ContactShareModal';
import BoothHeaderText from './BigBooth/BoothHeaderText';
import BoothLikeButton from './BoothLikeButton';
import { usePermission } from '../../../../../hooks/usePermission';

const BigBoothHeader = ({ booth }: { booth: Booth | undefined }) => {
  const event = useSelector(({ common }) => common.event);
  const user = useSelector(({ common }) => common.user);
  const isMobilePreview = useSelector(({ common }) => common.isMobilePreview);
  const { isBoothHost } = usePermission();

  if (!booth) return null;

  return (
    <div>
      <div className={`w-full space-y-1 flex justify-center flex-col ${isMobilePreview ? '' : 'lg:flex-row lg:justify-start'} grow px-12 items-center`}>
        {booth?.logo && <VyImage className="object-cover w-16 h-16 rounded" id={booth.logo} width={64} height={64} quality={80} alt={booth.name} />}
        <BoothHeaderText booth={booth} />
        <h2 className="font-bold text-center lg:pl-4 booth-name">
          <span> {booth.slogan}</span>
        </h2>
        {event?.modules.contactshare.active && booth.settings.displayContactShareInBooth.value && user && (
          <div className="flex flex-1">
            <ContactShareModal boothId={booth._id}>
              <VyButton event={event}>{event?.template.individualNames.contactShare}</VyButton>
            </ContactShareModal>
          </div>
        )}
        {event?.settings?.allowBoothLikes && user && <BoothLikeButton boothid={booth._id} />}
      </div>
    </div>
  );
};

export default BigBoothHeader;
